module.exports = __webpack_public_path__ + "static/img/4.695d721.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/zh/4.png
// module id = VQID
// module chunks = 0